// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2dOI2","disabled":"FileBtn_disabled__3E_2d","warn":"FileBtn_warn__2oRBd","fade":"FileBtn_fade__3Qq_l"};